import { render, staticRenderFns } from "./manutencao.vue?vue&type=template&id=a58fe9f4"
import script from "./manutencao.vue?vue&type=script&lang=js"
export * from "./manutencao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports